(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  if (!window.__kinzaCollectionBuyNowBound) {
    window.__kinzaCollectionBuyNowBound = true;
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-kinza-buy-now]');
      if (!button || button.disabled) return;

      const variantId = Number(button.dataset.variantId);
      if (!variantId) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Opening checkout…';

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });

        if (!response.ok) throw new Error('Unable to add item to cart');
        window.location.assign(`${root}checkout`);
      } catch (error) {
        console.error(error);
        button.disabled = false;
        button.textContent = originalText;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
